/**
 * facebook
 */
(function (d, s, id) {
	var js, fjs = d.getElementsByTagName(s)[0];
	if (d.getElementById(id)) return;
	js = d.createElement(s);
	js.id = id;
	js.src = "//connect.facebook.net/ja_JP/sdk.js#xfbml=1&version=v2.0";
	fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));

/**
 * Twitter
 */
(function (d, s, id) {
	var js, fjs = d.getElementsByTagName(s)[0], p = /^http:/.test(d.location) ? 'http' : 'https';
	if (!d.getElementById(id)) {
		js = d.createElement(s);
		js.id = id;
		js.src = p + '://platform.twitter.com/widgets.js';
		fjs.parentNode.insertBefore(js, fjs);
	}
})(document, 'script', 'twitter-wjs');

/**
 * Google+
 */
(function (d) {
	var scriptGoogle = d.createElement("script");
	scriptGoogle.src = "https://apis.google.com/js/platform.js";
	scriptGoogle.async = true;
	d.body.appendChild(scriptGoogle);
})(document);

/**
 * hatena
 */
(function (d) {
	var scriptHatena = d.createElement("script");
	scriptHatena.src = "https://b.st-hatena.com/js/bookmark_button.js";
	scriptHatena.async = true;
	d.getElementsByTagName("head")[0].appendChild(scriptHatena);
})(document);

/**
 * pocket
 */
(function (d, i) {
	if (!d.getElementById(i)) {
		var j = d.createElement("script");
		j.id = i;
		j.src = "https://widgets.getpocket.com/v1/j/btn.js?v=1";
		var w = d.getElementById(i);
		d.body.appendChild(j);
	}
})(document, "pocket-btn-js");
